
/**
 * Classe contendo as propriedades de endereço
 */
class DadosEndereco {

    /**
     * Cria uma nova instância da classe
     * @param {String} logradouro Logradouro (Rua, avenida)
     * @param {String} bairro Bairro referente ao endereço
     * @param {String} municipio Cidade/distrito do endereço
     * @param {String} uf Unidade federativa (Estado) do endereço
     * @param {String} cep Identificação do CEP do endereço
     */
    constructor(logradouro, bairro, municipio, uf, cep) {
        /** @member {String} logradouro Logradouro (Rua, avenida) */
        this.logradouro = logradouro ?? '';
        /** @member {String} bairro Bairro referente ao endereço */
        this.bairro = bairro ?? '';
        /** @member {String} municipio Cidade/distrito do endereço */
        this.municipio = municipio ?? '';
        /** @member {String} uf Unidade federativa (Estado) do endereço */
        this.uf = uf ?? '';
        /** @member {String} cep Identificação do CEP do endereço */
        this.cep = cep ?? '';
    }

    /**
     * Cria uma cópia do valor informado
     * @param {DadosEndereco} endereco Objeto a ser clonado
     * @returns {DadosEndereco} Nova instância com os mesmos valores
     */
    static clone(endereco) {
        return new DadosEndereco(endereco.logradouro, endereco.bairro, endereco.municipio, endereco.uf, endereco.cep);
    }

}

export default DadosEndereco;